import { render } from "@testing-library/react";
import ToolTip from "../../../ToolTip/ToolTip";

export const SMO_LEAD_TABLE_HEAD = [
  { field: "sl_no", headerName: "Sl No", width: 100 },
  { field: "admn_no", headerName: "Admn No", width: 100 },
  { field: "lead_name", headerName: "Student Name", width: 250 },
  { field: "lead_mob_no", headerName: "Contact No", width: 200 },
  { field: "lead_place", headerName: "Place", width: 150 },
  { field: "class_name", headerName: "Class", width: 150 },
  {
    field: "course_name",
    headerName: "Course Name",
    width: 200,
    renderCell: (params) => {
      return (
        <ToolTip
          content={params.row.course_name}
          expand={params.row.course_name}
        />
      );
    },
  },
  {
    field: "book_and_publication",
    headerName: "Book & Publications",
    width: 250,
    renderCell: (params) => {
      return (
        <ToolTip
          content={params.row.book_and_publication}
          expand={params.row.book_and_publication}
        />
      );
    },
  },
  { field: "total_session_count", headerName: "Total Sessions", width: 150 },
  { field: "smeName", headerName: "Assigned To", width: 250 },
  { field: "smoName", headerName: "Assigned By", width: 250 },
  { field: "oga_name", headerName: "OGA Name", width: 250 },
  { field: "cro_name", headerName: "CRO Name", width: 250 },
  { field: "sme_call_status_name", headerName: "Call Status", width: 200 },
];
